import { combineEpics } from 'redux-observable';
import { epics as categories } from 'src/categories';
import { epics as states } from 'src/states';
import { epics as townships } from 'src/townships';
import { epics as merchants } from 'src/merchants';
import { epics as members } from 'src/members';
import { epics as featuredAds } from 'src/featuredAds';
import { epics as featuredCategories } from 'src/featuredCategories';
import { epics as trendingCategories } from 'src/trendingCategories';

const epic = combineEpics(
  ...Object.keys(categories).map(k => categories[k]),
  ...Object.keys(featuredAds).map(k => featuredAds[k]),
  ...Object.keys(featuredCategories).map(k => featuredCategories[k]),
  ...Object.keys(trendingCategories).map(k => trendingCategories[k]),
  ...Object.keys(states).map(k => states[k]),
  ...Object.keys(townships).map(k => townships[k]),
  ...Object.keys(merchants).map(k => merchants[k]),
  ...Object.keys(members).map(k => members[k]),
);
export default epic;



// WEBPACK FOOTER //
// ./src/epic.ts